import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_cash_document_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    comp_code: fromDatatype.VarcharArrayDatatypeInterface;
    comp_guid: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_type: fromDatatype.VarcharArrayDatatypeInterface;
    ccy_code: fromDatatype.VarcharArrayDatatypeInterface;
    ref_no: fromDatatype.VarcharArrayDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    hdr_remarks: fromDatatype.TextDatatypeInterface;
    settlement_method: fromDatatype.VarcharArrayDatatypeInterface;
    settlement_type: fromDatatype.VarcharArrayDatatypeInterface;
    settlement_method_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_code: fromDatatype.VarcharArrayDatatypeInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    line_type: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_amount: fromDatatype.NumericDatatypeInterface
    line_remarks: fromDatatype.VarcharArrayDatatypeInterface;
    posting_status: fromDatatype.VarcharArrayDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: fromDatatype.VarcharArrayDatatypeInterface;
    processed: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    comp_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    ccy_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    ref_no_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    txn_date_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    slt_method_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    line_transfer_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_amount_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_line_amount_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_type_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
}

export class bl_fi_cash_document_file_helper_RowClass implements bl_fi_cash_document_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    comp_code: fromDatatype.VarcharArrayDatatypeInterface;
    comp_guid: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_type: fromDatatype.VarcharArrayDatatypeInterface;
    ccy_code: fromDatatype.VarcharArrayDatatypeInterface;
    ref_no: fromDatatype.VarcharArrayDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    hdr_remarks: fromDatatype.TextDatatypeInterface;
    settlement_method: fromDatatype.VarcharArrayDatatypeInterface;
    settlement_type: fromDatatype.VarcharArrayDatatypeInterface;
    settlement_method_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_code: fromDatatype.VarcharArrayDatatypeInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    line_type: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_amount: fromDatatype.NumericDatatypeInterface
    line_remarks: fromDatatype.VarcharArrayDatatypeInterface;
    posting_status: fromDatatype.VarcharArrayDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    validated: fromDatatype.VarcharArrayDatatypeInterface;
    processed: fromDatatype.VarcharArrayDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharArrayDatatypeInterface;
    comp_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    ccy_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    ref_no_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    txn_date_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    slt_method_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    line_transfer_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_amount_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_line_amount_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
    transfer_type_validate_error: fromDatatype.VarcharArrayDatatypeInterface;
}